/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit BoardListIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import MyBoardsIcon from './MyBoardsIcon/index'
import No from './No/index'
import OtherBoardsIcon from './OtherBoardsIcon/index'
import PrivateBoardIcon from './PrivateBoardIcon/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function BoardListIcon({
  children,
  viewPath = "/DesignSystem/TasksBoardsList/Boards/Content/Header/Content/Content/Content/Title/BoardListIcon"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let taskBoardsListTypeValueData = fromData.useDataFormat({ viewPath,
context: 'task_boards_list',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: taskBoardsListTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MyBoardsIcon'}>
<MyBoardsIcon
  viewPath={`${viewPath}/MyBoardsIcon`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PrivateBoardIcon'}>
<PrivateBoardIcon
  viewPath={`${viewPath}/PrivateBoardIcon`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherBoardsIcon'}>
<OtherBoardsIcon
  viewPath={`${viewPath}/OtherBoardsIcon`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}